import React from 'react'
import Navbar from '../component/Navbar/Navbar'
import BottomNavbar from '../component/BottomNavbar/BottomNavbar'
import Search from './Search'

export default function SearchContainer() {
  return (
    <>
    <Navbar/>
    <Search/>
    <BottomNavbar/>
    </>
  )
}
